<template>
  <div class="content_main">
    <p class="content_normal">We act as Solicitors to ULTIMCRED LIMITED, whom we shall hereafter
      refer to as Our Client and on whose instruction we now write.</p>
    <br />
    <p class="content_normal">Your Loan with SWIFTKASH has been overdue for over one week, our
      recovery team has tried reaching you to negotiate the loan, but cannot contact you or reach an
      agreement with you. We did not want to believe you are trying to abscond with the loan because
      we hold you in high esteem.</p>
    <br />
    <p class="content_normal">The company will also call your friends and family to report the
      situation to them.</p>
    <br />
    <p class="content_normal">In order to avoid affecting your reputation, please repay the loan as
      soon as possible after receiving the notice or contact us. If you have financial difficulties,
      we can apply for a 20% penalty interest reduction for you. After you have completed the
      repayment, if there is still a need for borrowing, you can apply for another loan.</p>
    <br />
    <p class="content_normal">After receiving the information, you can make payment by reaching out
      to our agent, or for complaints reach out to the support team on</p>
    <br />
    <p class="content_normal">WhatsApp: 09010401147</p>
    <p class="content_normal"> Email: bill@swiftkash.ng</p>
    <br />
    <p class="content_normal">Therefore, this letter requires you to pay and return it to the mail
      or company immediately.</p>
    <br />
    <p class="content_normal">Note: If you fail to pay, we will use all available methods to seek
      justice, which will obviously make you pay more.</p>
    <br />
    <p class="content_normal">While waiting for your prompt reply, do have the assurance of our best
      regard.</p>
    <br />
    <p class="content_normal">Regards.</p>

  </div>
</template>

<script>
export default {
  name: 'swiftM2',
};
</script>

<style lang="stylus" scoped>
px = (1 / 24.75vw);
.content {
  padding: 25 *px 16 *px;
  .content_main{
    line-height: 20px;
    text-indent: 16px;
    margin-top: 16px;
  }
  .content_normal {
    text-align: left;
    text-indent: 16px;
  }
}
</style>
